import { render, staticRenderFns } from "./TargetingMode.vue?vue&type=template&id=28638dd9&"
import script from "./TargetingMode.vue?vue&type=script&lang=js&"
export * from "./TargetingMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports